import React, { Suspense } from "react";
import FooterData from "../Footer/FooterData";

const Footer = React.lazy(() => import("../Footer/Footer"));

/** Site-wide footer (company menu, contact, bottom links). Rendered from LazyPageShell. */
export default function SiteFooter() {
  return (
    <div className="site-footer-shell">
      <Suspense fallback={null}>
        <Footer FooterData={FooterData} />
      </Suspense>
    </div>
  );
}
